var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMusician(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 495.864 495.864",
    style: {
      enableBackground: "new 0 0 495.864 495.864"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#3A666D"
    },
    cx: 247.932,
    cy: 28,
    rx: 47.664,
    ry: 28
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#2B525B"
    },
    cx: 247.932,
    cy: 92.656,
    rx: 92.336,
    ry: 82.672
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#C68D1A"
    },
    cx: 247.932,
    cy: 286.832,
    rx: 90,
    ry: 29.504
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E28F71"
    },
    points: "329.844,455.864 167.852,455.864 159.852,279.864 334.18,279.864 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AFA28B"
    },
    d: "M467.036,325.896l-121.552-42.072l2.568,1.096l-15.896-6.672 c-6.344,20.728-41.584,42.744-84.216,42.744c-42.648,0-77.872-22.024-84.208-42.752l-15.92,6.664l2.576-1.112l-121.56,42.112 L5.764,495.864H36.5h156.736h47.528h14.328h49.736h154.528h30.736L467.036,325.896z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#897E67"
    },
    d: "M95.932,495.864h97.304h47.528h14.328h49.736h154.528h30.736l-23.064-169.968l-121.552-42.072 l2.568,1.096l-15.896-6.672c-6.344,28.728-41.584,42.744-84.216,42.744c-42.648,0-71.816-17.96-84.208-42.752l-15.92,6.664 l2.576-1.112L28.828,325.904"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#897E67"
    },
    d: "M239.932,495.864H255.1h49.736h154.528H490.1l-23.064-169.968l-121.552-42.072l2.568,1.096 l-15.896-6.672c-6.344,20.728-42,42.808-84.64,42.808"
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#6D6250"
    },
    points: "423.932,495.864 459.364,495.864 490.1,495.864 467.036,325.896 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F9BDA0"
    },
    points: "309.172,300.8 190.204,281.896 196.556,199.864 301.132,199.864 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E28F71"
    },
    points: "309.188,300.8 261.38,315.552 188.516,199.864 301.14,199.864 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCCCB9"
    },
    d: "M327.772,132.304c0-70.032-31.84-98.368-79.84-98.648v-0.032v0.016v-0.016v0.032 c-48,0.28-79.84,28.616-79.84,98.648s31.84,133.352,79.84,134.856v0.144c0,0,0-0.064,0-0.072c0,0.008,0,0.072,0,0.072v-0.144 C295.932,265.656,327.772,202.336,327.772,132.304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BDA0"
    },
    d: "M247.932,263.864v3.44c0,0,0-0.064,0-0.072c0,0.008,0,0.072,0,0.072v-0.144 c48-1.504,79.84-64.832,79.84-134.856s-31.84-98.368-79.84-98.648v-0.032v0.016v-0.016v-1.76"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77502A"
    },
    d: "M167.844,111.056c-4.328-1.896-3.472-30.736,0.344-39.424c3.832-8.704,10.456-6.2,14.768-4.296 c4.344,1.904,23.936,20.784,16.936,27.192"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M203.74,215.12c-0.2-0.224-0.312-0.376-0.312-0.376S203.5,214.968,203.74,215.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M293.956,215.12c0.2-0.224,0.312-0.376,0.312-0.376S294.188,214.968,293.956,215.12z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D39D24"
    },
    d: "M184.156,102.672c0,0,6.232,18.704-2.512,29.936c0,0-2.496,1.248-3.096,6.856 c-0.64,5.616,5.968,21.984,12.512,53.792c2.168,10.544,8.032,39.152,25.512,29.168l4.152,1.872c0,0-4.8,24.328,27.2,23.704v21.832 c0,0-32.2,3.112-54.656-28.072c-22.464-31.184-25.96-76.144-25.336-101.096c0.64-24.952-5.832-36.776-0.832-45.504 C172.092,86.432,184.156,102.672,184.156,102.672z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B77F0F"
    },
    d: "M311.708,102.672c0,0-6.232,18.704,2.496,29.936c0,0,2.496,1.248,3.112,6.856 c0.64,5.616-5.968,21.984-12.512,53.792c-2.16,10.536-8.048,39.152-25.504,29.168l-4.152,1.872c0,0,4.784,24.328-27.216,23.704 v21.832c0,0,32.216,3.112,54.656-28.072c22.456-31.176,25.952-73.48,25.344-98.432c-0.64-24.952,5.816-39.44,0.832-48.168 C323.772,86.432,311.708,102.672,311.708,102.672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B77F0F"
    },
    d: "M263.708,73.328c0,0,8,41,63,48c0,0,34-77-50-89S263.708,73.328,263.708,73.328z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D39D24"
    },
    d: "M286.708,64.328c0,0-35,73-112,56c0,0-31-39,17-78s100-26,104-6S286.708,64.328,286.708,64.328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A666D"
    },
    d: "M167.932,177.664c0,9.4-6.624,9-16,9l0,0c-9.392,0-16-7.608-16-17v-45.328c0-9.392,6.608-17,16-17 l0,0c9.392,0,16,7.608,16,17V177.664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B525B"
    },
    d: "M151.604,107.336L151.604,107.336c9.392,0,16.328,7.608,16.328,17v53.328c0,9.4-7.288,9-16.664,9l0,0 "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#83B5BA"
    },
    cx: 152.572,
    cy: 143.328,
    r: 2.664
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A666D"
    },
    d: "M327.932,177.664c0,9.4,6.624,9,16,9l0,0c9.392,0,16-7.608,16-17v-45.328c0-9.392-6.608-17-16-17l0,0 c-9.392,0-16,7.608-16,17V177.664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B525B"
    },
    d: "M344.26,107.336L344.26,107.336c-9.392,0-16.328,7.608-16.328,17v53.328c0,9.4,7.288,9,16.664,9l0,0"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#83B5BA"
    },
    cx: 343.26,
    cy: 143.328,
    r: 2.664
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D3C7B4"
    },
    points: "247.932,384.272 199.932,394.784 199.932,381.648 247.932,371.128 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AFA28B"
    },
    points: "199.932,384.944 199.932,463.864 207.932,463.864 207.932,382.408 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D3C7B4"
    },
    points: "186.66,492.176 169.668,475.208 200.708,444.192 211.356,467.472  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D3C7B4"
    },
    points: "327.932,344.68 279.932,355.192 279.932,342.032 327.932,331.52  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AFA28B"
    },
    points: "279.932,345.352 279.932,431.864 287.932,423.864 287.932,342.8 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D3C7B4"
    },
    points: "265.1,452.584 248.124,435.616 279.156,404.584 289.812,427.88 "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusician);
export default __webpack_public_path__ + "static/media/musician.72370433dd2790b49a44b7a3e0b481e3.svg";
export { ForwardRef as ReactComponent };